import  { number_format } from "../../../../config/Helpers";
import { max } from "moment";
import echarts from 'echarts/lib/echarts';


export const rateChart = (rate) => {
    const real_rate = rate / 100;
    const option = {
        tooltip : false,
        series: [
            {
                name: '业务指标',
                type: 'gauge',
                data: [{value: rate, name: '完成率'}],
                label: false,
                title : false,
                axisLine : {
                    lineStyle: {
                        color: [[real_rate, '#7ed321'],[1, '#9ccbff'],[1, '#9ccbff']],
                        width : 20
                    }
                },
                detail : {
                    shadowColor : '#fff', 
                    shadowBlur: 5,
                    offsetCenter: [0, '95%'],
                    formatter : '{value}%',
                    color : "#4990e2",
                    fontSize : 22
                },
                axisLabel : {
                  show : false  
                },
                axisTick :{
                    show : false
                },
                splitLine : {
                    show : false
                },
                markArea: {
                    label : false
                },
                markLine :{
                    label : false
                },
                pointer : {
                    width: 2
                },
                itemStyle : {
                    color :  "#4990e2"
                },
            }
        ]
    };
    return option;
}

export const rateByHotel = (data_rate_hotel) => {
    const option = {
        tooltip: false,
        title: false,
        grid: {
            left: '25px',
            right: '4%',
            bottom: '35px',
            top: '25px',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            axisLabel :{
                formatter : '{value}%'
            }
        },
        yAxis: {
            type: 'category',
            data: data_rate_hotel.names,
            
        },
        series: [
            { // For shadow
                type: 'bar',
                itemStyle: {
                    normal: {color: '#9ccbff'}
                },
                barGap:'-100%',
                barCategoryGap:'40%',
                data: data_rate_hotel.percent_total_hotels
            },
            {
                name: '2011年',
                type: 'bar',
                itemStyle: {
                    normal: {color: '#4990e2'}
                },
                data: data_rate_hotel.values
            }
        ]
    };
    return option;
}

export const rateByProduction = (data_production) => {

    let option = {
        tooltip: {
            show : false
        },
        legend: {
            orient: 'vertical',
            data : data_production.names,
            top : "25px",
            right : "25px",
            type : "scroll",
            width : "400px",
            height : "150px"
        },
        series: {
            name:'访问来源',
            type:'pie',
            radius: ['30%', '60%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            left : 0,
            label : {
                show : true,
                formatter : "{c} R/N",
                fontSize : 12,
                color : "#FFF",
                backgroundColor : "#4990e2",
                borderRadius : 5,
                padding : 3

            },
            itemStyle: {
                emphasis: {
                    shadowBlur: 17,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            data: data_production.values
        }
    };
    
    return option;
}

export const rateByTrending = (data_trending_time) => {

    let option = {
        legend: {
            orient : "vertical",
            data: data_trending_time.property_names,
            top : "25px",
            right : "25px"
        },
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}%"
        },
        grid: {
            left: '3%',
            right: '250px',
            bottom: '3%',
            top : "25px",
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: data_trending_time.month_names
        },
        yAxis: {
            type: 'value',
            boundaryGap: true,
            axisLabel : {
                formatter : "{value}%"
            }
        },
        series: data_trending_time.values
    };
    
    return option;
}
export const calendarTrending = (data_year_trending) => {
    let option = {
        tooltip : {},
        visualMap: {
            show : false,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            top: 'top',
            min : 0,
            max : data_year_trending["max_value"],
        },
        calendar: [
        {
            range: data_year_trending["year_value"],
            cellSize: ["auto"],
            left : 25,
            right : 25,
            top : 25,
            yearLabel : {
                color : "#4da1ff",
                show: false
            },
            dayLabel : {
                nameMap: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
            },
            monthLabel : {
                formatter: function (param) {
                    const months = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
                    const index = parseInt(param.MM) - 1;
                    return months[index];
                }
            }
        }],
        
        series : data_year_trending["series"]
    };
    return option
}

export const degreeOccupancyTime  = (data_degree_occupancy_time) => {

    let option = {
        legend: {
            orient : "vertical",
            data: data_degree_occupancy_time.type_names,
            top : "25px",
            right : "25px"
        },
        tooltip : {
            trigger: 'item',
            //formatter: "{a} <br/>{b} : {c} R/N"
            formatter : function (params, ticket, callback) {
                return params.name + ": " + number_format(params.value) + " R/N";
            }
        },
        grid: {
            left: '3%',
            right: '150px',
            bottom: '3%',
            top : "25px",
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: data_degree_occupancy_time.month_names,
        },
        yAxis: {
            type: 'value',
            boundaryGap: true,
            axisLabel : {
                formatter : function(value, index){
                    return number_format(value) + " R/N"
                }
            }
        },
        series: data_degree_occupancy_time.values
    };
    return option;
}



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/widgets/Charts.js